// @givmo/board — the way back to an account's boards, at a board page's top right (CBG-UX10).
//
// In the officer Board's frame the sidebar is the way between a board's pages, so a page's header
// carries no way home of its own. An account on several boards, or on none it can open, still has a
// list to go back to: "All your boards" (approved), or "All your committees" beside a committee's
// header (CBG-FIX104). For an account home lands on one seat for (`landingSeat`, CBG-FIX109) there is
// no such list, so nothing shows; it waits for `/me` rather than flashing up before it.

import { testIdProp } from '@givmo/design-system';
import { Link } from '../../board-routing';
import { BOARD_DIRECTOR_PAGES } from '../../board-routes';
import { landingSeat } from '../../director/director-board';
import type { DirectorMe } from '../../director/director-wire';
import { committeeOnlyWords as co } from '../committees/committee-only-words';

const LINK =
  'font-sans text-s14 font-w600 tracking-givmo text-brand-600 outline-none transition-colors hover:text-brand-700 focus-visible:underline';

export function AllYourBoards({
  me,
  settled,
  committeeOnly,
  testId,
}: {
  /** `/me`, and whether it has answered (`useDirectorBoardAddress`). */
  me: DirectorMe | undefined;
  settled: boolean;
  /** The page's seat is a committee's, for someone who isn't on the board. */
  committeeOnly: boolean;
  testId: string;
}) {
  if (!settled || landingSeat(me) !== null) return null;
  return (
    <Link
      to={BOARD_DIRECTOR_PAGES.home}
      // Exact: this page sits beneath that address, and it is not the current page.
      exact
      className={LINK}
      {...testIdProp(testId)}
    >
      {committeeOnly ? co.allYourCommittees : 'All your boards'}
    </Link>
  );
}
